export default __webpack_public_path__ + "static/media/default-student-profile.6e2f2bf3.jpg";